import { render, staticRenderFns } from "./MailingAddressQuestion.vue?vue&type=template&id=3638facb&scoped=true&"
import script from "./MailingAddressQuestion.vue?vue&type=script&lang=ts&"
export * from "./MailingAddressQuestion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3638facb",
  null
  
)

export default component.exports